export default "__VITE_ASSET__X3Y9H7ji3HewbyaGyBtl_Q__"